import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { WorkspaceSettings } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { reportError } from 'utils/error'

export interface Data {
  company: WorkspaceSettings
}

export type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

export interface Variables {
  app_logo_url?: string | null
  white_label_color?: string | null
  is_ads_testing_enabled?: boolean
}

export const updateWorkspaceSettings = async ({ workspaceKey, ...variables }: Variables & { workspaceKey: string }) => {
  const response = await sendToApi<Data>(`/w/${workspaceKey}/settings/workspace`, {
    method: 'PUT',
    body: {
      workspace: variables,
    },
    params: { include: ['version_control_mode.metadata'] },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to update workspace settings', {
      metaData: {
        variables,
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useUpdateWorkspaceSettings = (workspaceKey: string, options?: Options) => {
  return useMutation<Data, unknown, Variables>(
    ['workspaces', workspaceKey, 'updateSettings'],
    (variables) => updateWorkspaceSettings({ workspaceKey, ...variables }),
    options,
  )
}
